import clsx from 'clsx';
import { ChevronDownIcon } from 'lucide-react';

export default function Select({
  label,
  description,
  options,
  className,
  selectedClassName,
  size = 'md',
  ...props
}) {
  const sizeClass = {
    sm: 'p-2 text-sm rounded-md',
    md: 'p-2 text-base rounded-lg',
    lg: 'p-4 text-lg rounded-xl',
  };

  return (
    <div className={clsx('w-full', className)}>
      {label && (
        <label
          htmlFor="location"
          className="block text-sm/6 font-medium text-gray-900"
        >
          {label}
        </label>
      )}
      <div className="grid grid-cols-1">
        <select
          {...props}
          className={clsx(
            'col-start-1 row-start-1 w-full rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none pr-6',
            sizeClass[size],
            selectedClassName,
          )}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        <ChevronDownIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-2 size-5 self-center justify-self-end text-gray-500 sm:size-4"
        />
      </div>
    </div>
  );
}
